import React, {FC} from "react"

import FormattedMessage, {injectIntl, InjectIntl} from "@irati/utils/lang"
import {H3, Body} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"

import {Img, BenefitsCard, BenefitsContainer} from "./styled"

interface Props extends InjectIntl {}

const Benefits: FC<Props> = ({formatMessage}) => {
  return (
    <BenefitsContainer gap={3} padding={[2, 4]}>
      <BenefitsCard>
        <Flex direction="column" alignItems="center">
          <Img large src={formatMessage({id: "admin.components.integration.directorySync.hris.benefits.item1.img"})} />
          <H3 marginTop={2} textAlign="center">
            <FormattedMessage id="admin.components.integration.directorySync.hris.benefits.item1.title" />
          </H3>
          <Body small textAlign="center" marginTop>
            <FormattedMessage id="admin.components.integration.directorySync.hris.benefits.item1.text" />
          </Body>
        </Flex>
      </BenefitsCard>
      <BenefitsCard>
        <Flex direction="column" alignItems="center">
          <Img large src={formatMessage({id: "admin.components.integration.directorySync.hris.benefits.item2.img"})} />
          <H3 marginTop={2} textAlign="center">
            <FormattedMessage id="admin.components.integration.directorySync.hris.benefits.item2.title" />
          </H3>
          <Body small textAlign="center" marginTop>
            <FormattedMessage id="admin.components.integration.directorySync.hris.benefits.item2.text" />
          </Body>
        </Flex>
      </BenefitsCard>
      <BenefitsCard>
        <Flex direction="column" alignItems="center">
          <Img large src={formatMessage({id: "admin.components.integration.directorySync.hris.benefits.item3.img"})} />
          <H3 marginTop={2} textAlign="center">
            <FormattedMessage id="admin.components.integration.directorySync.hris.benefits.item3.title" />
          </H3>
          <Body small textAlign="center" marginTop>
            <FormattedMessage id="admin.components.integration.directorySync.hris.benefits.item3.text" />
          </Body>
        </Flex>
      </BenefitsCard>
    </BenefitsContainer>
  )
}

export default injectIntl(Benefits)
